import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { LANG_EN_TRANS } from '../../translation/lang-en';
import { LANG_TH_TRANS } from '../../translation/lang-th';
import { Language } from 'app/model/constant';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {

  constructor(
    private appConfigService: AppConfigService
  ) { }

  transform(value: any, replaceWith?: any, replaceValue?: any): any {
    let str: string;
    switch (this.appConfigService.getLanguage()) {
      case Language.th:
        str = LANG_TH_TRANS[value];
        break;
      default:
        str = LANG_EN_TRANS[value];
        break;
    }
    return str && replaceWith && replaceValue ? str.replace(new RegExp(replaceWith, 'g'), replaceValue) : str;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/translate.pipe.ts